import loadable from '@loadable/component'

const AsyncPage = ({page, ...props}) => {
    const PageComponent = loadable(() => import( /* webpackPrefetch: true */ `../${page}`), { cacheKey: () => page })

    return <PageComponent {...props} />
}

export default AsyncPage